import { cn } from "@/utils/utils";
import { useDelegateEmployees } from "./useDelegateEmployees";
import { Card } from "@/components/ui/card";
import { Body } from "@hypercard/web-components";
import { Switch } from "@/components/ui/switch";
import { useState } from "react";
import { useUpdateDelegateTransactionAccessMutation } from "@common/utils/graphql";

export const DelegateTransactionsVisibility = () => {
  const { delegateEmployees, delegateHasTransactionAccess } =
    useDelegateEmployees();
  const hasDelegates = delegateEmployees.length > 0;

  const [checked, setChecked] = useState(delegateHasTransactionAccess);

  const [updateDelegateTransactionAccess] =
    useUpdateDelegateTransactionAccessMutation();

  const handleOnCheckedChange = async (newChecked: boolean) => {
    setChecked(newChecked);
    await updateDelegateTransactionAccess({
      variables: {
        toggleDelegateTransactionAccess: newChecked,
      },
    });
  };

  return (
    <div
      className={cn("mt-12 transition-opacity", {
        "opacity-50": !hasDelegates,
      })}
    >
      <Card className="flex max-w-xl items-center justify-between space-x-6 p-6">
        <div className="space-y-1">
          <Body size="lg" weight="medium">
            Allow delegate view to see all transactions
          </Body>
          <Body size="sm" weight="regular" className="text-white/70">
            Delegate will have access to transactions to create Expense Reports
            from all transactions as opposed to just your drafted reports
          </Body>
        </div>
        <Switch
          checked={checked}
          onCheckedChange={handleOnCheckedChange}
          disabled={!hasDelegates}
        />
      </Card>
    </div>
  );
};
